import React, { useCallback, useEffect, useState } from 'react';
import { FieldArray } from 'formik';

import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { SelectTeammateViewModel } from 'api/backofficeApiClient';
import InternalReportSectionArray from './InternalReportSectionArray';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { getPartnerAndChildUsersList } from 'redux/reducers/assignmentSlice';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  companyId?: string;
};

export default function InternalReportFieldArray(props: Props) {
  const { companyId } = props;
  const isAdmin = useAppSelector(isAdminSelector);
  const [partnersAndChildUsersList, setPartnersAndChildUsersList] = useState<
    SelectTeammateViewModel[]
  >([]);
  const [
    isPartnersAndChildUsersListLoaded,
    setIsPartnersAndChildUsersListLoaded,
  ] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    loadPartnerAndChildUsersList();
    // eslint-disable-next-line
  }, []);

  const loadPartnerAndChildUsersList = useCallback(async () => {
    const result = await dispatch(
      getPartnerAndChildUsersList({ isAdmin, companyId }),
    );

    if (getPartnerAndChildUsersList.fulfilled.match(result)) {
      setPartnersAndChildUsersList(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }

    setIsPartnersAndChildUsersListLoaded(true);
  }, [dispatch, isAdmin, companyId]);

  return (
    <FieldArray
      name="internalReports"
      render={(props) => (
        <InternalReportSectionArray
          {...props}
          teammates={partnersAndChildUsersList}
          isTeammatesLoaded={isPartnersAndChildUsersListLoaded}
        />
      )}
    />
  );
}
